import { useState, useEffect, createContext } from 'react';

export type ProfileState = {
  hsaList: any;
  basicList: any;
  setHsaList: (list: any) => void,
  setBasicList: (list: any) => void,
}

export const ProfileStore = createContext<ProfileState>({
  hsaList: {},
  basicList: {},
  setHsaList: (list) => {},
  setBasicList: (list) => {},
});

const { Provider } = ProfileStore;

export const ProfileProvider = ({ children }: any) => {
  const [hsaList, setHsaList] = useState<any>({"beneficiary":{"id":"2","name":"Pat Smith","relationship":"spouse","image":""},"contingents":[{"id":"3","name":"Morgan Smith","relationship":"child","image":""}]}); 
  const [basicList, setBasicList] = useState<any>({"beneficiary": {}, "contingents": []}); 

  return <Provider value={{hsaList, basicList, setHsaList, setBasicList}}>{children}</Provider>;
}
